import React from 'react'
import {
  Swiper,
  SwiperSlide
} from 'swiper/react'
import { A11y, Keyboard, Mousewheel, Navigation } from 'swiper'

import Card from '@/molecules/Card'

import {
  StyledDefaultSlider,
  StyledDefaultSliderNavigation,
  StyledDefaultSliderNavigationButton
} from './styles'
import Icon from '@/atoms/Icon'

const swiperProps = {
  spaceBetween: 24,
  slidesPerView: 'auto',
  breakpoints: { 768: { spaceBetween: 60, }, },
  keyboard: true,
  navigation: {
    nextEl: '.slider-button-next',
    prevEl: '.slider-button-prev',
  },
}

const DefaultSlider = ({
  list,
  type,
  columns = 3,
}) => (
  <StyledDefaultSlider columns={columns} >
    <Swiper
      {...swiperProps}
      modules={[Keyboard, Mousewheel, Navigation, A11y]}
      aria-label="Slider di contenuti"
      aria-roledescription="carousel"
    >
      {
        list.map((item, i) => (
          <SwiperSlide
            key={`${i}_${item.title}`}
            role="group"
            aria-roledescription="slide"
            aria-label={`${i + 1} di ${list.length}: ${item.title || 'Contenuto'}`}
          >
            <Card key={`${i}_${item.title}`} item={item} type={type} imageRatio={item.imageRatio} />
          </SwiperSlide>
        ))
      }

      <StyledDefaultSliderNavigation aria-label="Controlli slider">
        <StyledDefaultSliderNavigationButton
          className='slider-button-prev'
          aria-label="Vai al contenuto precedente"
          type="button"
        >
          <Icon name='chevron-left' aria-hidden='true' />
        </StyledDefaultSliderNavigationButton>
        <StyledDefaultSliderNavigationButton
          className='slider-button-next'
          aria-label="Vai al contenuto successivo"
          type="button"
        >
          <Icon name='chevron-right' aria-hidden='true' />
        </StyledDefaultSliderNavigationButton>
      </StyledDefaultSliderNavigation>
    </Swiper>
  </StyledDefaultSlider>
)

export default DefaultSlider
